{
  "until": "{{duration}} a {{prayer}}",
  "begin_focus": "Inizia il focus",
  "add_task": "Aggiungi attività",
  "more_tasks": "+{{count}} altre",
  "fajr_at": "Fajr alle {{time}}",
  "schedule_title": "Oggi",
  "plan_my_day": "Pianifica la giornata",
  "planning": "Pianificazione…",
  "suggested": "Suggerito",
  "keep_plan": "Mantieni piano",
  "undo_plan": "Annulla",
  "plan_error": "Impossibile pianificare ora. Riprova.",
  "plan_empty": "Niente da pianificare — aggiungi prima un'attività.",
  "plan_settled": "È già tutto al suo posto.",
  "view_list": "Elenco",
  "view_switch_aria": "Passa tra vista elenco e vista giorno",
  "unassigned": "Non pianificate",
  "assign_title": "Blocco di preghiera",
  "no_block": "Nessun blocco",
  "assign_aria": "Assegna a un blocco di preghiera",
  "open_schedule_aria": "Apri il programma di oggi",
  "focus_session_label": "{{block}} · Focus",
  "block_hero": "Lavoro profondo fino a {{prayer}}",
  "moments_away": "{{prayer}} è a pochi istanti",
  "block_clear": "Tutto fatto — riposa fino a {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Esc per uscire in silenzio",
  "exit_hint_touch": "Tocca ✕ per uscire in silenzio",
  "mark_done_aria": "Segna attività come completata",
  "quick_add_placeholder": "Aggiungi a questo blocco…",
  "focus_task_aria": "Concentrati su questa attività"
}
